export enum TrialClassBookingTypeEnum {
  REGULAR = 1,
  REFERRAL = 2,
  RETRIAL = 3,
}

export enum CourseGroupEnum {
  ALL = 0,
  SL = 1,
  SPTCH = 2,
  RBLX = 3,
  MATHS = 4,
  PHYSICS = 5,
  CHEMISTRY = 6,
  COMP_MATHS = 7,
}

export enum CourseLevelEnum {
  L1 = 1,
  L2 = 2,
  L3 = 3,
}

export enum UserGenderEnum {
  MALE = 1,
  FEMALE = 2,
}

export enum StudentStatusEnum {
  TRIAL_PENDING = 1,
  TRIAL_DONE = 2,
  PAID = 3,
  INACTIVE = 4,
}

export enum PaymentModeEnum {
  OFFLINE = 1,
  ONLINE = 2,
  PAYMENT_GATEWAY = 3,
  NOSHOW_CUT = 4,
}

export enum PaymentStatusEnum {
  INITIATED = 1,
  IN_PROGRESS = 2,
  COMPLETED = 3,
}

export enum PaymentGatewayTypeEnum {
  BANK_TRANSFER = 1,
  CASH = 2,
  PAYPAL = 3,
  PAYU = 4,
  RAZORPAY = 5,
  STRIPE = 6,
  TAZAPAY = 7,
  JAMBOREE = 8,
  SKYLINK = 9,
  TRANSFER = 10,
  CREDITS = 11,
  REFUND = 12,
  REFERRAL_BONUS = 13,
  OTHER = 99,
}

export enum StudentCourseStatusEnum {
  TRIAL_PENDING = 1,
  TRIAL_SCHEDULED = 2,
  TRIAL_COMPLETED = 3,
  PAID = 4,
}

export enum SlotStatusIdEnum {
  OPENED = 1,
  DISABLED = 2,
  CLOSED = 3,
  BOOKED = 4,
}

export enum SessionStatusIdEnum {
  PENDING = 1,
  STARTED = 2,
  COMPLETED = 3,
  CANCELLED = 4,
  RESCHEDULED = 5,
  STUDENT_NOSHOW = 6,
  STUDENT_TECH_NOSHOW = 7,
  TEACHER_NOSHOW = 8,
  TEACHER_TECH_NO_SHOW = 9,
  TUTOR_CHANGED = 10,
}

export enum DemoSessionStatusIdEnum {
  UNASSIGNED = 1,
  ASSIGNED = 2,
  CANCELLED = 3,
}

export enum SessionCancellationReasonEnum {
  STUDENT_INITIATED = 1,
  RESCHEDULE_REQUESTED = 2,
  NOT_RESPONDING = 3,
  NOT_INTERESTED = 4,
  INVALID_WHATSAPP_OR_MOBILE = 5,
  LANGUAGE_ISSUE = 6,
  INTERNET_ELECTRICITY_PROBLEM = 7,
  SOFTWARE_HARDWARE_ISSUE = 8,
  IRREGULAR_STUDENT = 9,
  TUTOR_EMERGENCY_LEAVE = 10,
  OTHER = 99,
}

export enum SessionStatusDetailIdEnum {
  CLASS_COMPLETED = 1,
  RESCHEDULE_REQUESTED = 2,
  NOT_RESPONDING = 3,
  NOT_INTERESTED = 4,
  INVALID_WHATSAPP_OR_MOBILE = 5,
  LANGUAGE_ISSUE = 6,
  INTERNET_ELECTRICITY_PROBLEM = 7,
  SOFTWARE_HARDWARE_ISSUE = 8,
  IRREGULAR_STUDENT = 9,
  TUTOR_EMERGENCY_LEAVE = 10,
  OTHER = 99,
}

export enum TutorSessionCategoryEnum {
  PENDING = 1,
  STARTED = 2,
  COMPLETED = 3,
  CANCELLED = 4,
}

export enum ValidTutorSessionCategoryEnum {
  PENDING = 1,
  STARTED = 2,
  COMPLETED = 3,
}

export enum SectionTypeEnum {
  LESSON_PLAN = 1,
  ASSESSMENT = 2,
  EXPLANATION = 3,
  STUDENT_ACTIVITY = 4,
  TEACHER_ACTIVITY = 5,
  EXPLANATION_AND_STUDENT_ACTIVITY = 6,
  VIDEO = 7,
}

export enum StudentReportTypeEnum {
  ASSESSMENT_REPORT = 1,
  ASSESSMENT_REPORT_REVIEW = 2,
  CERTIFICATE = 3,
  CERTIFICATE_IMAGE = 4,
  PROJECT = 5,
  APP = 6,
  WRONG_LINKS = 7,
}

export enum TutorTabEnum {
  SESSIONS = "Sessions",
  UNASSIGNED_DEMOS = "UnassignedDemos",
  TUTOR_CALENDAR = "TutorCalendar",
  SESSION_REPORTS = "SessionReports",
}

export enum ExtraProjectStatusEnum {
  ACTIVE = 1,
  INACTIVE = 2,
}
